import React,{Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';

const ArrowContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: flex-start;
`;


const ArrowBackStandar = (props) => {
    const { text, history } = props;

    const handleBack = () =>{
        history.goBack();
    };

    return ( 
        <>
            <ArrowContainer onClick={handleBack}>
                <div className="flexContainer--center">
                    <img src="/img/0-icons-blue-arrow-back.svg" alt="logo" />
                    <Typography
                    color="primary"
                    style={{
                        fontSize: 16,
                        fontWeight: 'bold',
                        lineHeight: 1,
                        paddingBottom: 4,
                        marginLeft: 8
                    }}
                    >
                    {text}
                    </Typography>
                </div>
            </ArrowContainer>
        </>
     );
}
 
export default withRouter(ArrowBackStandar);
